import React from 'react';
import { Item, registry, RenderProps } from '../Item';
import { EDITABLE_LINK_BUTTON } from '../itemIds';
import { EditableLinkButton } from './EditableLinkButton';

interface Props {
  url: string;
}

export class EditableLinkButtonItem extends Item<
  typeof EDITABLE_LINK_BUTTON,
  Props
> {
  protected render({ id, url, children }: RenderProps<Props>) {
    return (
      <EditableLinkButton id={id} url={url}>
        {children}
      </EditableLinkButton>
    );
  }
}

registry[EDITABLE_LINK_BUTTON] = EditableLinkButtonItem;
